/**
 * Layout component for update pages
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { IntlProvider } from "react-intl"

// self host Google Fonts:
import "@fontsource-variable/plus-jakarta-sans"

import "./styles/update.css"

const UpdatePageLayout = ({ children, location, title, locale }) => {
  //const url = location.pathname

  return (
    <IntlProvider locale={locale}>
      <div className="update">{children}</div>
    </IntlProvider>
  )
}

UpdatePageLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default UpdatePageLayout
